import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RStringComponent } from './r-string/r-string.component';
import { RTextareaComponent } from './r-textarea/r-textarea.component';
import { RNumberComponent } from './r-number/r-number.component';
import { RRadioComponent } from './r-radio/r-radio.component';
import { RCheckboxComponent } from './r-checkbox/r-checkbox.component';
import { RSelectComponent } from './r-select/r-select.component';
import { RDateComponent } from './r-date/r-date.component';
import { RDateRangeComponent } from './r-date-range/r-date-range.component';
import { GDatePipe } from './r-date/date-pipe.pipe';
import { GDateRangePipe } from './r-date-range/date-range-pipe.pipe';
import { RConNumberDecimalComponent } from './r-con-number-decimal/r-con-number-decimal.component';
import { RConNumberFloatComponent } from './r-con-number-float/r-con-number-float.component';
import { RConNumberIntegerComponent } from './r-con-number-integer/r-con-number-integer.component';
import { RConStringComponent } from './r-con-string/r-con-string.component';
import { RConBooleanComponent } from './r-con-boolean/r-con-boolean.component';
import { RConFixedComponent } from './r-con-fixed/r-con-fixed.component';
import { RConTimestampComponent } from './r-con-timestamp/r-con-timestamp.component';
import { RTitleComponent } from './r-title/r-title.component';

import { RGroupsComponent } from './r-groups/r-groups.component';
import { DSharedModule } from '../../shared';
import { SHARED_DELON_MODULES } from '../../shared-delon.module';
import { DynamicComponentModule, DynamicComponentRegistryService } from '../../dynamic-component';
import { SHARED_ZORRO_MODULES } from '../../shared-zorro.module';
import { RWidgetControlComponent } from '../r-widget-control/r-widget-control.component';
import { RImageComponent } from './r-image/r-image.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { RColorpickerComponent } from './r-colorpicker/r-colorpicker.component';
import { RRateComponent } from './r-rate/r-rate.component';
import { RSliderComponent } from './r-slider/r-slider.component';
import { RSplitlineComponent } from './r-splitline/r-splitline.component';
import { RTextComponent } from './r-text/r-text.component';
import { RUeditorComponent } from './r-ueditor/r-ueditor.component';
import { RUploadfileComponent } from './r-uploadfile/r-uploadfile.component';
import { GUeditorComponent } from './r-ueditor/g-ueditor.component';

export const COMPONENTS = [
  GUeditorComponent,
  RWidgetControlComponent,

  RStringComponent,
  RTextareaComponent,
  RNumberComponent,

  RRadioComponent,
  RCheckboxComponent,
  RSelectComponent,
  RDateComponent,
  RDateRangeComponent,

  RTitleComponent,
  RGroupsComponent,

  RConStringComponent,
  RConNumberDecimalComponent,
  RConNumberFloatComponent,
  RConNumberIntegerComponent,
  RConFixedComponent,
  RConBooleanComponent,
  RConTimestampComponent,
  RImageComponent,

  RSliderComponent,
  RRateComponent,
  RUeditorComponent,
  RTextComponent,
  RUploadfileComponent,
  RSplitlineComponent,
  RColorpickerComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    DynamicComponentModule,
    ColorPickerModule,
    DSharedModule
  ],
  declarations: [...COMPONENTS, GDatePipe, GDateRangePipe],
  exports: [...COMPONENTS, GDatePipe, GDateRangePipe]
})
export class WidgetRenderModule {
  constructor(registryService: DynamicComponentRegistryService) {
    // 控件注册
    registryService.setDefault(RStringComponent);
    registryService.register(RStringComponent.KEY, RStringComponent);
    registryService.register(RTextareaComponent.KEY, RTextareaComponent);
    registryService.register(RNumberComponent.KEY, RNumberComponent);
    registryService.register(RRadioComponent.KEY, RRadioComponent);
    registryService.register(RCheckboxComponent.KEY, RCheckboxComponent);
    registryService.register(RSelectComponent.KEY, RSelectComponent);
    registryService.register(RDateComponent.KEY, RDateComponent);
    registryService.register(RDateRangeComponent.KEY, RDateRangeComponent);
    registryService.register(RTitleComponent.KEY, RTitleComponent);
    registryService.register(RGroupsComponent.KEY, RGroupsComponent);

    registryService.register(RConStringComponent.KEY, RConStringComponent);
    registryService.register(RConNumberDecimalComponent.KEY, RConNumberDecimalComponent);
    registryService.register(RConNumberFloatComponent.KEY, RConNumberFloatComponent);
    registryService.register(RConNumberIntegerComponent.KEY, RConNumberIntegerComponent);
    registryService.register(RConFixedComponent.KEY, RConFixedComponent);
    registryService.register(RConBooleanComponent.KEY, RConBooleanComponent);
    registryService.register(RConTimestampComponent.KEY, RConTimestampComponent);
    registryService.register(RImageComponent.KEY, RImageComponent);
    registryService.register(RSliderComponent.KEY, RSliderComponent);
    registryService.register(RRateComponent.KEY, RRateComponent);
    registryService.register(RUeditorComponent.KEY, RUeditorComponent);
    registryService.register(RTextComponent.KEY, RTextComponent);
    registryService.register(RUploadfileComponent.KEY, RUploadfileComponent);
    registryService.register(RSplitlineComponent.KEY, RSplitlineComponent);
    registryService.register(RColorpickerComponent.KEY, RColorpickerComponent);
  }
}
